import { Controller } from "@hotwired/stimulus"

// Auto-loads the next page when its "load more" link scrolls into view.
// The link itself does the work (data-turbo-stream="true"); this controller
// just clicks it so the visitor never has to. Each response replaces this
// element with either the next page's version (new link, fresh observer) or
// an empty one once there's nothing left to load.
export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.observer = new IntersectionObserver(this.load.bind(this), { rootMargin: "400px" })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  load(entries) {
    if (!this.hasLinkTarget) return
    if (!entries.some((entry) => entry.isIntersecting)) return

    this.observer.disconnect()
    this.linkTarget.click()
  }
}
